(() => {
  const QTY_RE = /(adet|miktar|paket)/i;
  const productCache = new Map();

  const parseQuantity = (text) => {
    const match = String(text || '').replace(',', '.').match(/\d+(?:\.\d+)?/);
    return match ? Number(match[0]) : 0;
  };

  const formatTry = (cents) => {
    try {
      return new Intl.NumberFormat('tr-TR', {
        style: 'currency',
        currency: 'TRY',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(cents / 100);
    } catch (_) {
      return `${(cents / 100).toFixed(2).replace('.', ',')} TL`;
    }
  };

  const getProductJson = async (productInfo) => {
    let url = productInfo?.dataset?.url || window.location.pathname;
    if (!url) return null;
    url = url.split('?')[0].replace(/\.js$/, '');
    if (productCache.has(url)) return productCache.get(url);

    const promise = fetch(`${url}.js`, { credentials: 'same-origin' })
      .then((response) => {
        if (!response.ok) throw new Error(`Product JSON ${response.status}`);
        return response.json();
      })
      .catch((error) => {
        console.warn('[PlexiGo] Adet başı fiyat verisi alınamadı:', error);
        return null;
      });

    productCache.set(url, promise);
    return promise;
  };

  const optionGroups = (variantSelects) =>
    Array.from(variantSelects.querySelectorAll('fieldset, .product-form__input--dropdown'));

  const groupName = (group) => {
    const legend = group.querySelector('legend');
    if (legend) return legend.textContent.trim();
    const label = group.querySelector('.form__label');
    return label ? label.textContent.trim() : '';
  };

  const selectedValue = (group) => {
    const checked = group.querySelector('input[type="radio"]:checked');
    if (checked) return checked.value;
    const select = group.querySelector('select');
    return select ? select.value : null;
  };

  const ensureLabel = (input) => {
    if (!input.id) return null;
    const label = input.parentElement?.querySelector(`label[for="${CSS.escape(input.id)}"]`) ||
      document.querySelector(`label[for="${CSS.escape(input.id)}"]`);
    if (!label) return null;
    label.classList.add('plexigo-unit-price-label');
    let small = label.querySelector('.plexigo-unit-price-label__value');
    if (!small) {
      small = document.createElement('small');
      small.className = 'plexigo-unit-price-label__value';
      small.setAttribute('aria-hidden', 'true');
      label.appendChild(small);
    }
    return small;
  };

  const updatePicker = async (variantSelects) => {
    if (!variantSelects || variantSelects.dataset.plexigoUnitPriceUpdating === 'true') return;
    variantSelects.dataset.plexigoUnitPriceUpdating = 'true';
    try {
      const productInfo = variantSelects.closest('product-info');
      const product = await getProductJson(productInfo);
      if (!product?.variants?.length) return;

      const groups = optionGroups(variantSelects);
      const selected = groups.map(selectedValue);

      groups.forEach((group, optionIndex) => {
        if (!QTY_RE.test(groupName(group))) return;

        group.querySelectorAll('input[type="radio"]').forEach((input) => {
          const qty = parseQuantity(input.value);
          const small = ensureLabel(input);
          if (!small) return;

          if (!qty || qty <= 1) {
            small.textContent = '';
            small.hidden = true;
            return;
          }

          const target = [...selected];
          target[optionIndex] = input.value;

          let variant = product.variants.find((v) =>
            Array.isArray(v.options) &&
            v.options.length === target.length &&
            v.options.every((value, i) => String(value) === String(target[i]))
          );

          if (!variant) {
            variant = product.variants.find((v) =>
              Array.isArray(v.options) && String(v.options[optionIndex]) === String(input.value)
            );
          }

          if (!variant || typeof variant.price !== 'number') {
            small.textContent = '';
            small.hidden = true;
            return;
          }

          small.hidden = false;
          small.textContent = `${formatTry(variant.price / qty)} / adet`;
        });
      });
    } finally {
      delete variantSelects.dataset.plexigoUnitPriceUpdating;
    }
  };

  const refresh = (root = document) => {
    const pickers = root.matches?.('variant-selects') ? [root] : Array.from(root.querySelectorAll?.('variant-selects') || []);
    pickers.forEach((picker) => updatePicker(picker));
  };

  document.addEventListener('DOMContentLoaded', () => refresh());

  // Listen passively after Shopify's own variant machinery. We never prevent/stop events.
  document.addEventListener('change', (event) => {
    const picker = event.target.closest?.('variant-selects');
    if (picker) window.setTimeout(() => updatePicker(picker), 0);
  });

  // Taste replaces variant-selects after each server-rendered variant update.
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) continue;
        refresh(node);
      }
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
  refresh();
})();
